export default "__VITE_ASSET__Bqg0pPTq__"